/**
 * HT Automotriz - WhatsApp CTA Tracking
 * Mide clics en botones de WhatsApp y los reporta a GA4 + Meta Pixel
 * Versión: 1.0 - Sep 2026
 */

document.addEventListener('DOMContentLoaded', function () {

  // === BOTÓN: Producto CON STOCK ===
  var btnInstock = document.querySelector('.js-btn-whatsapp-instock');
  if (btnInstock) {
    btnInstock.addEventListener('click', function () {
      var productName = btnInstock.getAttribute('data-product-name') || document.querySelector('.product-name') && document.querySelector('.product-name').innerText || '';
      var productSku  = btnInstock.getAttribute('data-product-sku')  || document.querySelector('[data-js-product-sku] span') && document.querySelector('[data-js-product-sku] span').innerText || '';
      var productUrl  = window.location.href;

      // GA4
      if (typeof gtag === 'function') {
        gtag('event', 'whatsapp_consulta_instock', {
          event_category: 'WhatsApp CTA',
          event_label: productName,
          product_name: productName,
          product_sku: productSku,
          page_url: productUrl
        });
      }

      // Meta Pixel
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', {
          content_name: productName,
          content_ids: [productSku],
          status: 'instock'
        });
      }
    });
  }

  // === BOTÓN: Producto AGOTADO (sensor de demanda) ===
  var btnSoldOut = document.querySelector('.js-btn-sold-out');
  if (btnSoldOut) {
    btnSoldOut.addEventListener('click', function () {
      var productName = btnSoldOut.getAttribute('data-product-name') || document.querySelector('.product-name') && document.querySelector('.product-name').innerText || '';
      var productSku  = btnSoldOut.getAttribute('data-product-sku')  || document.querySelector('[data-js-product-sku] span') && document.querySelector('[data-js-product-sku] span').innerText || '';
      var productUrl  = window.location.href;

      // GA4 - evento de demanda insatisfecha
      if (typeof gtag === 'function') {
        gtag('event', 'whatsapp_demanda_agotado', {
          event_category: 'Demanda Insatisfecha',
          event_label: productName,
          product_name: productName,
          product_sku: productSku,
          page_url: productUrl
        });
      }

      // Meta Pixel - retargeting cuando vuelva el stock
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', {
          content_name: productName,
          content_ids: [productSku],
          status: 'sold_out_demand'
        });
      }
    });
  }

  // === BOTÓN: Producto CONTRAPEDIDO ===
  var btnBackorder = document.querySelector('.js-btn-whatsapp-backorder');
  if (btnBackorder) {
    btnBackorder.addEventListener('click', function () {
      var productName = btnBackorder.getAttribute('data-product-name') || document.querySelector('.product-name') && document.querySelector('.product-name').innerText || '';
      var productSku  = btnBackorder.getAttribute('data-product-sku')  || document.querySelector('[data-js-product-sku] span') && document.querySelector('[data-js-product-sku] span').innerText || '';
      var productUrl  = window.location.href;

      // GA4
      if (typeof gtag === 'function') {
        gtag('event', 'whatsapp_contrapedido', {
          event_category: 'Contrapedido Fábrica',
          event_label: productName,
          product_name: productName,
          product_sku: productSku,
          page_url: productUrl
        });
      }

      // Meta Pixel
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', {
          content_name: productName,
          content_ids: [productSku],
          status: 'backorder'
        });
      }
    });
  }

});
